module.exports = __webpack_public_path__ + "fonts/31E180_4_0.67c8a72.woff2";